import { readJson, writeJson } from './storage'

const KEY = 'veracruz.anonymousId'

// Identificador anónimo del navegador (spec `tree-reports`): aleatorio, sin datos de la
// persona. Permite medir participación y que un segundo aviso del día sustituya al primero.
// Si no se puede guardar, se genera uno por visita (el aviso sigue funcionando).
export const getAnonymousId = (
	storage: Storage | undefined = globalThis.localStorage,
	generate: () => string = () => crypto.randomUUID()
): string => {
	const stored = readJson<string | null>(KEY, null, storage)
	if (stored && /^[A-Za-z0-9_-]{8,64}$/.test(stored)) return stored
	const fresh = generate()
	writeJson(KEY, fresh, storage)
	return fresh
}
